const isValidName = (domains, name) => {
  const filteredDomains = domains.filter((domain) => domain.name === name)
  return filteredDomains && filteredDomains.length === 1
}

export default { isValidName }
